import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as TickCircleIcon } from '../../assets/icons/tick-circle-icon.svg';

interface TimeRangeDropdownProperties {
  selected: string;
  onSelect: (value: string) => void;
}

/**
 * Custom dropdown component for selecting time ranges
 * @param {TimeRangeDropdownProperties} properties - The properties for the dropdown
 * @returns {JSX.Element} The rendered dropdown component
 */
function TimeRangeDropdown({ selected, onSelect }: TimeRangeDropdownProperties) {
 const {t} = useTranslation('sharedComponent')
  const options = [
    { key: 'today', label: t('today') },
    { key: 'yesterday', label: t('yesterday') },
    { key: 'week', label: t('week') },
    { key: 'month', label: t('month') },
    { key: 'year', label: t('year') },
  ];

  return (
    <div className="time-range-dropdown">
      {options.map((option) => (
        <div
          key={option.key}
          className={`dropdown-option ${selected === option.key ? 'selected' : ''}`}
          onClick={() => onSelect(option.key)}
          role="button"
          tabIndex={0}
          onKeyDown={(even) => {
            if (even.key === 'Enter' || even.key === ' ') {
              even.preventDefault();
              onSelect(option.key);
            }
          }}>
          <span>{option.label}</span>
          {selected === option.key && <TickCircleIcon />}
        </div>
      ))}
    </div>
  );
}

export default TimeRangeDropdown;
